import { DEALER } from "@/config/dealers";

export { DEALER };
export const COMPANY = DEALER.company;
export const FEATURES = DEALER.features;
export const COPY = DEALER.copy;

export const waLink = (text) =>
  `${COMPANY.whatsapp}?text=${encodeURIComponent(text || DEALER.waGreeting)}`;

export const vehicleUrl = (v) => `${window.location.origin}/fahrzeuge/${v.id}`;

export const vehicleWaText = (v) => DEALER.waVehicle(v, vehicleUrl(v));

export const mapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(COMPANY.mapsQuery)}&hl=de&z=15&output=embed`;
export const mapsRouteUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(COMPANY.mapsQuery)}`;

export const fmtPrice = (n) =>
  new Intl.NumberFormat("de-AT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export const fmtKm = (n) =>
  `${new Intl.NumberFormat("de-AT").format(n || 0)} km`;
